var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',{staticClass:"elevation-0 mb-2",attrs:{"tile":"","color":"primary"}},[_c('v-card-title',{staticClass:"font-weight-medium grey--text pt-1 pb-2"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")]),_vm._v(" "),_c('v-card-subtitle',{staticClass:"pb-2"},[_vm._v("\n        "+_vm._s(_vm.subtitle)+"\n      ")])],1),_vm._v(" "),_c('v-card',{staticClass:"elevation-0 mt-3",attrs:{"tile":""}},[_c('h5',[_vm._v("Esta funcionalidad aun no existe.")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/Todo.vue?vue&type=template&id=412aef2f
// module id = null
// module chunks = 